import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getJiraIssues } from '@api';

export const getJiraIssuesSlice = createGetAsyncSlice({
	name: 'jiraIssues',
	receive: true,
	request: true,
	requestHandler: getJiraIssues,
	retainDataOnRequest: true
});
